import prefersReducedMotion from '../services/utilities';

class TextChange {
    textNodes = null;

    numberNode = null;

    constructor() {
        this.textNodes = jQuery('.text-typing');
        this.numberNodes = jQuery('.scale-up-number');

        if (prefersReducedMotion) {
            // eslint-disable-next-line
            this.textNodes.each((index, textNode) => textNode.innerText = textNode.dataset.text);
            // eslint-disable-next-line
            this.numberNodes.each((index, numberNode) => numberNode.innerText = numberNode.dataset.number);
        } else {
            this.init();
        }
    }

    init() {
        this.textNodes.each((index, textNode) => {
            const textNode$ = textNode;

            TextChange.textTyping(textNode$);
            textNode$.onanimationend = () => textNode$.classList.add('completed');
        });

        this.numberNodes.each((index, numberNode) => {
            TextChange.numberScaleUp(numberNode);
        });
    }

    static textTyping(node) {
        const $node = jQuery(node);
        const text = $node.data('text');
        const textCount = text.length;
        let pos = 0;

        const typing = setInterval(() => {
            if (text[pos] === '*') {
                $node.html(`${$node.html()}<br />`);
            } else {
                $node.html($node.html() + text[pos]);
            }

            pos += 1;

            if (pos === textCount) {
                clearInterval(typing);
                $node.addClass('ready');
            }
        }, 100);
    }

    static numberScaleUp(node) {
        const $node = jQuery(node);
        const countTo = $node.attr('data-number');
        let func = TextChange.getCurrentNumber;

        if ($node.hasClass('with-plus')) {
            func = TextChange.getCurrentNumberPoint;
        }

        jQuery({countNum: $node.text()}).animate(
            {
                countNum: countTo,
            },
            {
                duration: 4000,
                easing: 'linear',
                step: (countNum) => {
                    $node.text(func(countNum));
                },
            },
        );
    }

    static getCurrentNumberPoint(val) {
        let currentValue = val;

        currentValue = Math.floor(currentValue);

        if (currentValue > 999) {
            currentValue = String(currentValue);
            return `${currentValue.slice(0, -3)}.${currentValue.substring(-3, 3)}`;
        }
        return currentValue;
    }

    static getCurrentNumber(val) {
        return Math.floor(val);
    }
}

export default function initializeTextChange() {
    return new TextChange();
}
